import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import SuiteFeatureTableBadge from '../common/SuiteFeatureTableBadge';
import CurrentPlanButton from '../suite-starter-page/CurrentPlanButton';
import FeatureTableCTA from './FeatureTableCTA';
const TableHeaderCell = styled.th.withConfig({
  displayName: "CompareProFeatureTableHeaderCell__TableHeaderCell",
  componentId: "sc-4f2t71-0"
})(["text-align:center;font-weight:normal;position:relative;background-color:", ";box-shadow:", ";width:", ";padding:16px 0;vertical-align:bottom;"], ({
  isStaticHeader,
  isHighlightedCell
}) => !isStaticHeader && isHighlightedCell && `${OLAF}`, ({
  isStaticHeader,
  isHighlightedCell
}) => !isStaticHeader && isHighlightedCell && 'inset 0px 4px 4px rgba(124, 152, 182, 0.2)', ({
  columns
}) => columns < 3 ? `calc(50%/${columns})` : `calc(70%/${columns})`);
const badgeStyle = {
  top: '16px',
  left: 0,
  right: 0,
  margin: '12px auto',
  width: 'fit-content'
};
const ctaStyles = {
  width: '212px',
  padding: '11px'
};

const CompareProFeatureTableHeaderCell = ({
  productLevel,
  columns,
  productLine,
  isStaticHeader,
  upgradePointProductLevel,
  ownedProductColumn,
  upgradePointApiName
}) => {
  const isHighlightedCell = upgradePointProductLevel === productLevel; // Seats scenarios have only one column because we don't have an additional column for a product to compare.

  const isSeatsScenario = columns <= 1;
  return /*#__PURE__*/_jsxs(TableHeaderCell, {
    isHighlightedCell: isHighlightedCell,
    columns: columns,
    scope: "col",
    isStaticHeader: isStaticHeader,
    children: [isHighlightedCell && /*#__PURE__*/_jsx(SuiteFeatureTableBadge, {
      use: 'new',
      translationKey: 'recommended',
      badgeStyle: badgeStyle
    }), /*#__PURE__*/_jsx("strong", {
      className: "m-y-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        className: "flex-column m-y-4",
        message: `merchCards.businessObjectives.suite.${productLevel}.${productLine}.title`
      })
    }), ownedProductColumn && !isSeatsScenario ? /*#__PURE__*/_jsx(CurrentPlanButton, {
      ctaStyles: Object.assign({}, ctaStyles, {
        visibility: 'visible'
      }),
      productLine: productLine
    }) : /*#__PURE__*/_jsx(FeatureTableCTA, {
      productLevel: productLevel,
      productLine: productLine,
      upgradePointApiName: upgradePointApiName
    })]
  }, productLevel);
};

export default CompareProFeatureTableHeaderCell;